import React from 'react';
import SVG from 'react-inlinesvg';
import { toAbsoluteUrl } from '../AssetHelpers';
type Props = {
  className?: string;
  path: string;
  svgClassName?: string;
  isSVGData?: boolean;
};

const KTSVG: React.FC<Props> = ({
  className = '',
  path,
  svgClassName = 'mh-50px',
  isSVGData,
}) => {
  return (
    <span className={`svg-icon ${className}`}>
      <SVG
        src={isSVGData ? path : toAbsoluteUrl(path)}
        className={svgClassName}
      />
    </span>
  );
};

export { KTSVG };
